import { PopupModal } from "components/modals/ModalBox";
import React from "react";
import useButtonLoader from "hooks/useButtonLoader";
import { deleteUserApi } from "services/user";
import { toastMessage } from "utils/toastMessage";
import { deleteReportApi } from "services/report";

const DeleteWarning = ({
  selectedUserDetail,
  onClose,
  deleteModel,
  refetchUserList
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoader(true);
      const { data: responseData, status } = await deleteReportApi({
        _id: selectedUserDetail,
        type: "COMMENT"
      });
      refetchUserList();
      onClose();
      toastMessage(responseData.message, "success", "deleteUser");
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModel}
        handleClose={onClose}
        title="Are you sure you want to Remove this report?"
        content="If you remove this report then this reported issue will be considered as not relevant."
        buttonLoader={buttonLoader}
        action={changeDeleteHandler}
      />
    </>
  );
};

export default DeleteWarning;
